function Alert(props)
{
    return (
        props.type === "success" ? <div className='alert alert-success alert-dismissible fade show' role='alert'>
        <strong>Success! </strong> 
        {props.message}
        <button type='button' className='close' data-dismiss='alert' aria-label='Close'>
            <span aria-hidden='true'>&times;</span>
        </button>
    </div> :(props.type === "error" ? <div className='alert alert-danger alert-dismissible fade show' role='alert'>
            <strong>Error! </strong> 
            {props.message}
            <button type='button' className='close' data-dismiss='alert' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
            </button>
        </div> : <div></div>)
    );
}


export default Alert;